import React, { useRef } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { PrimaryButton } from '../components';
import { useIntl } from 'react-intl';

import css from './BilingDetailsForm.module.css';
import BillingDetailsFields from './BillingDetailsFields';

const BillingDetailsForm = props => {
  const { initialValues, onSubmit, inProgress, error } = props;
  const intl = useIntl();
  const submittedValuesRef = useRef({}); // ✅ safe storage

  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, pristine, invalid, values }) => {
        const submitInProgress = inProgress;

        const submittedOnce = Object.keys(submittedValuesRef.current).length > 0;

        const pristineSinceLastSubmit =
          submittedOnce && JSON.stringify(values) === JSON.stringify(submittedValuesRef.current);

        const submitDisabled = invalid || pristine || pristineSinceLastSubmit || submitInProgress;
        return (
          <form
            className={css.form}
            onSubmit={e => {
              submittedValuesRef.current = values;
              handleSubmit(e);
            }}
          >
            <BillingDetailsFields />
            {error && <div className={css.error}>{error}</div>}

            <div className={css.actions}>
              <PrimaryButton
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={pristineSinceLastSubmit}
              >
                {intl.formatMessage({ id: 'BillingDetailsForm.saveChanges' })}
              </PrimaryButton>
            </div>
          </form>
        );
      }}
    />
  );
};

export default BillingDetailsForm;
